var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLessonPrevArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_435_680)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 30C18.9782 30 22.7935 28.4196 25.6068 25.6068C28.4198 22.7938 30 18.9783 30 15C30 11.0218 28.4196 7.20651 25.6068 4.39326C22.7938 1.58026 18.9783 1.42952e-05 15 1.39474e-05C12.367 1.37173e-05 9.78025 0.693089 7.5 2.00959C5.21973 3.32619 3.32625 5.21984 2.0095 7.50009C0.693001 9.78036 -7.47524e-05 12.3671 -7.49826e-05 15.0001C-7.53304e-05 18.9783 1.5803 22.7936 4.39318 25.6068C7.20618 28.4198 11.0217 30.0001 14.9999 30.0001L15 30ZM7.5 14.97C7.49492 14.6439 7.62266 14.3299 7.854 14.1L12.792 9.17699C13.097 8.87161 13.5417 8.75199 13.9587 8.86331C14.3757 8.97464 14.7016 9.30004 14.8137 9.71684C14.9257 10.1336 14.8069 10.5786 14.502 10.884L11.61 13.779L21.3 13.779C21.7287 13.779 22.1249 14.0078 22.3392 14.379C22.5536 14.7503 22.5536 15.2077 22.3392 15.579C22.1248 15.9503 21.7287 16.179 21.3 16.179L11.5829 16.179L14.502 19.098L14.5019 19.098C14.8073 19.4034 14.9267 19.8487 14.8149 20.2659C14.703 20.6832 14.3772 21.0092 13.9599 21.121C13.5426 21.2327 13.0974 21.1135 12.7919 20.808L7.8539 15.885C7.62636 15.6588 7.49883 15.3509 7.4999 15.03L7.5 14.97Z",
    fill: "#CCCCCC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_435_680"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white",
    transform: "translate(30 30) rotate(-180)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLessonPrevArrow);
export default __webpack_public_path__ + "static/media/lessonPrevArrow.c2802fe630c69fe449748fe74024dafe.svg";
export { ForwardRef as ReactComponent };